// Multivariate Dependencies
import React from 'react';
// Styles
import { LinkBase } from '../styles/LinkBase';
// Utils
import { getLinkStylePropertiesBySize } from '../utils/getLinkStylePropertiesBySize';
export var Link = function (_a) {
    var href = _a.href, children = _a.children, size = _a.size, target = _a.target, id = _a.id, onClick = _a.onClick;
    var _b = getLinkStylePropertiesBySize(size), fontSize = _b.fontSize, lineHeight = _b.lineHeight;
    return (React.createElement(LinkBase, { id: id, display: 'inline', href: href, fontSize: fontSize, lineHeight: lineHeight, target: target, fontWeight: '400', cursor: 'pointer', textDecoration: 'none', onClick: onClick }, children));
};
//# sourceMappingURL=Link.js.map